fragment SettingsFragment on Settings {
    primary_language
    pcs_brackets
    languages
    currency
}